// extracted by mini-css-extract-plugin
export var formContainer = "_dq-0";
export var message = "_dq-1";